import { Vorgang } from '../../types';

export function berechneReparaturdauer(vorgang: Vorgang): number {
  const arbeitswerteProStunde = parseFloat((vorgang?.reparaturdauer?.arbeitswerteProStunde ?? '') || '0') || 10;
  const arbeitswerte = parseFloat((vorgang?.dat?.arbeitswerte ?? '') || '0');
  const materialbeschaffungsdauer = parseFloat((vorgang?.reparaturdauer?.materialbeschaffungsdauer ?? '') || '1');

  return Math.ceil(arbeitswerte / arbeitswerteProStunde + materialbeschaffungsdauer);
}
